<template>
    <article class="hp-card tw-relative lg:tw-ease-out lg:tw-duration-200 lg:hover:tw-translate-y-[-4px]">
        <a
            class="hp-card__link tw-absolute tw-top-0 tw-left-0 tw-h-full tw-w-full"
            :href="href"
            :title="title"
            rel="bookmark"
        >
        </a>
        <header class="hp-card__img tw-h-auto xl:tw-h-[220px] tw-w-full">
            <img
                class="tw-rounded tw-max-w-full tw-bg-slate-100 tw-h-full tw-object-cover"
                :class="{ lazyload: $attrs['data-src'] }"
                :src="$attrs['data-src'] ? fakeImg : imageSrc"
                :alt="title"
                :data-src="$attrs['data-src'] ? $attrs['data-src'] : null"
                :data-srcset="$attrs['data-srcset'] ? $attrs['data-srcset'] : null"
            >
        </header>
        <div class="hp-card__body tw-mt-4">
            <div class="tw-flex tw-items-center tw-justify-between">
                <dk-badge v-if="isGuide" class="tw-mb-1" type="light" size="small">
                    {{ categoryName }}
                </dk-badge>
                <dk-badge
                    v-else-if="categoryName && categorySlug"
                    type="light"
                    size="small"
                    :category-slug="categorySlug"
                    is-article-badge
                >
                    <span>{{ categoryName }}</span>
                </dk-badge>
                <dk-badge v-else :type="'light'" :size="'small'">
                    <span class="tw-text-slate-700 tw-mr-2">{{ badgeText }}</span>
                    <dk-icon name="ds-formula-passion" :size="'xs'" />
                </dk-badge>
                <span v-if="publishedOn" class="caption tw-text-base-subtle">{{ publishedOn }}</span>
            </div>
            <h3 class="hp-card__title subtitle-md tw-text-base-subtle tw-mt-2">
                {{ postTitle }}
            </h3>
            <p v-if="excerpt" class="caption tw-text-base-subtle">
                {{ excerpt }}
            </p>

            <dk-button v-if="readAllText" class="tw-mt-2 md:tw-hidden">
                {{ readAllText }}
            </dk-button>
        </div>
    </article>
</template>

<script>
import { fakeImg } from '@v4/common/utils';

export default {
    name: 'DkNewsCard',
    components: {
        DkIcon: () => ({
            component: import(/* webpackChunkName: "DkIcon-vue" */ '@v4/common/components/atoms/DkIcon.vue'),
        }),
        DkBadge: () => ({
            component: import(/* webpackChunkName: "DkBadgeDST-vue" */ '@v4/common/components/atoms/DkBadgeDST.vue'),
        }),
        DkButton: () => ({
            component: import(/* webpackChunkName: "DkButton-vue" */ '@v4/common/components/atoms/DkButton.vue'),
        }),
    },
    inheritAttrs: false,
    props: {
        href: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        postTitle: {
            type: String,
            required: true,
        },
        excerpt: {
            type: String,
            default: null,
        },
        publishedOn: {
            type: String,
            default: null,
        },
        imageSrc: {
            type: String,
            required: true,
        },
        categoryName: {
            type: String,
            default: null,
        },
        categorySlug: {
            type: String,
            default: null,
        },
        badgeText: {
            type: String,
            default: '',
        },
        isGuide: {
            type: Boolean,
            default: false,
        },
        readAllText: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            fakeImg,
        };
    },
};
</script>
